import {
  USER,
  ADMIN_USERNAME,
  ADMIN_TOKEN,
  SIGNIN,
  ROUTE,
  TOKEN
 } from '../constants';


const initialStateUser = {
  user: null,
  isSignedIn: false,
  route: 'home',
  token: null
}

export const user = (state=initialStateUser, action={}) => {
  switch (action.type) {
    case USER:
      return Object.assign({}, state, {user: action.payload})
    case SIGNIN:
      return Object.assign({}, state, {isSignedIn: action.payload})
    case ROUTE:
      return Object.assign({}, state, {route: action.payload})
    case TOKEN:
      return Object.assign({}, state, {token: action.payload})
    default:
      return state
  }
}
const initialStateAdmin = {
  username: null,
  token: null
}

export const admin = (state=initialStateAdmin, action={}) => {
  switch (action.type) {
    case ADMIN_USERNAME:
      return Object.assign({}, state, {username: action.payload})
    case ADMIN_TOKEN:
      return Object.assign({}, state, {token: action.payload})
    default:
      return state
  }
}